/*
  Toggle del modal "Tabla de tallas" custom de LINA.

  - Click en [data-lina-size-chart-open] abre el modal del mismo .lina-size-chart
  - Click en [data-lina-size-chart-close] o en el backdrop lo cierra
  - ESC también cierra
  - Bloquea el scroll del body mientras está abierto
*/
(function () {
  function openModal(modal) {
    if (!modal) return;
    // Portal: sacar el modal de cualquier ancestro con transform (scroll-trigger de Dawn),
    // que si no "atrapa" el position:fixed y descoloca el modal.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    document.body.classList.add('lina-size-chart-open');
    // Focus en el botón de cerrar para accesibilidad
    var closeBtn = modal.querySelector('[data-lina-size-chart-close]');
    if (closeBtn) {
      setTimeout(function () { closeBtn.focus(); }, 50);
    }
  }

  function closeAllModals() {
    var modals = document.querySelectorAll('[data-lina-size-chart-modal]');
    modals.forEach(function (m) { m.hidden = true; });
    document.body.classList.remove('lina-size-chart-open');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-lina-size-chart-open]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      var wrapper = openBtn.closest('.lina-size-chart');
      // Tras moverlo al body ya no está dentro del wrapper: buscamos también a nivel global.
      var modal = (wrapper && wrapper.querySelector('[data-lina-size-chart-modal]'))
        || document.querySelector('[data-lina-size-chart-modal]');
      openModal(modal);
      return;
    }

    var closeEl = e.target.closest('[data-lina-size-chart-close]');
    if (closeEl) {
      e.preventDefault();
      e.stopPropagation();
      closeAllModals();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeAllModals();
    }
  });
})();
